import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {timeOutline, timeSharp} from "ionicons/icons"
import {useHistory} from "react-router";
import Key from "@customTypes/Key";

interface props {
    keyItem: Key
}

const ListItemButtonKeyTimeLimits: React.FC<props> = ({ keyItem }) => {

    const {t} = useTranslation()
        , history = useHistory()
        , [presentAlert] = useIonAlert()
        , translationKey: string = "keys.alerts." + (keyItem.keyTimeLimits ? 'time_limits' : 'no_time_limits')

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToKeyView = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (keyItem.keyTimeLimits) {
            return history.push('/keys-in-use/' + keyItem.id + '/view')
        }

        alertMessage(ev).then()
    }

    return (
        <IonButton color={keyItem.keyTimeLimits ? "medium" : "light"} fill="clear"
                   onClick={ (ev) => goToKeyView(ev) }
                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
            <IonIcon slot="start" ios={timeOutline} md={timeSharp} />
        </IonButton>
    )
}

export default ListItemButtonKeyTimeLimits